import type { AppConfig } from '@/types/config';

/**
 * Reduce a configured `i18n.fallbackLng` (string, array, or per-locale map)
 * to a single language string for call sites that need one locale id
 * (URL prefixes, detectors, resource keys, etc.).
 *
 * For arrays / map `default` chains, the last entry is the ultimate fallback.
 */
export function resolveFallbackLanguage(fallbackLng: AppConfig['i18n']['fallbackLng']): string {
    if (typeof fallbackLng === 'string') return fallbackLng;
    if (Array.isArray(fallbackLng)) {
        return fallbackLng.at(-1) ?? 'en-GB';
    }
    if (fallbackLng && typeof fallbackLng === 'object') {
        const fromMap = (fallbackLng as { readonly default?: readonly string[] }).default;
        if (Array.isArray(fromMap)) return fromMap.at(-1) ?? 'en-GB';
    }
    return 'en-GB';
}
